export type PendingLivenessDialogChallengeStatus = 'pending' | 'approved' | 'denied' | null;

export type PendingLivenessDialogLaunchStatus = 'loading' | 'opened' | 'blocked' | 'unavailable';

export type PendingLivenessDialogState = {
  isVisible: boolean;
  challengeId: string | null;
  challengeStatus: PendingLivenessDialogChallengeStatus;
  launchStatus: PendingLivenessDialogLaunchStatus;
  url: string | null;
};

type PendingLivenessDialogListener = (state: PendingLivenessDialogState) => void;
type PendingLivenessDialogOpenHandler = () => Promise<void>;

const defaultState: PendingLivenessDialogState = {
  isVisible: false,
  challengeId: null,
  challengeStatus: null,
  launchStatus: 'loading',
  url: null,
};

let state: PendingLivenessDialogState = defaultState;
let openHandler: PendingLivenessDialogOpenHandler | null = null;

const listeners = new Set<PendingLivenessDialogListener>();

const emitChange = () => {
  listeners.forEach((listener) => listener(state));
};

export const getPendingLivenessDialogState = () => state;

export const subscribePendingLivenessDialog = (listener: PendingLivenessDialogListener) => {
  listeners.add(listener);
  listener(state);

  return () => {
    listeners.delete(listener);
  };
};

export const showPendingLivenessDialog = (nextState: Partial<PendingLivenessDialogState> = {}) => {
  state = {
    ...state,
    isVisible: true,
    ...nextState,
  };

  emitChange();
};

export const clearPendingLivenessDialog = () => {
  state = defaultState;
  emitChange();
};

export const registerPendingLivenessDialogOpenHandler = (
  handler: PendingLivenessDialogOpenHandler,
) => {
  openHandler = handler;
};

export const openPendingLivenessDialogLink = async () => {
  if (!openHandler) {
    return;
  }

  await openHandler();
};
